import { Button } from '@/shared/ui/Button'

type JourneysListEmptyProps = {
  filtered?: boolean
  onClearFilter?: () => void
}

export const JourneysListEmpty = ({
  filtered,
  onClearFilter
}: JourneysListEmptyProps) => (
  <div className="py-10 text-center">
    <p className="mb-2 font-bold text-sm text-gray-800">
      {filtered
        ? 'Nenhuma jornada neste filtro'
        : 'Nenhuma jornada disponível'}
    </p>
    <p className="mb-4 text-gray-500">
      {filtered
        ? 'Tente outro filtro para ver mais experiências.'
        : 'Volte mais tarde para descobrir novas experiências.'}
    </p>
    {filtered && onClearFilter && (
      <Button variant="secondary" size="sm" showTrailingIcon={false} onClick={onClearFilter}>
        Ver todas
      </Button>
    )}
  </div>
)
